import { render, staticRenderFns } from "./DiagnosticScale.vue?vue&type=template&id=28a0bc85&scoped=true"
import script from "./DiagnosticScale.vue?vue&type=script&lang=js"
export * from "./DiagnosticScale.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticScale.vue?vue&type=style&index=0&id=28a0bc85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0bc85",
  null
  
)

export default component.exports